export enum TemplatesEnum {
  BICIKLO = "BICIKLO",
  DRUGO = "DRUGO",
}
